import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import TossPayment from '../Toss/TossPayment';
import RefundPolicyModal from '../Toss/RefundPolicyModal';
import getApiBaseUrl from './getApiBaseUrl';
import './Charge.scss';

const Charge = () => {
  const userInfo = useSelector((state) => state.appReducer.userInfo);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showRefundModal, setShowRefundModal] = useState(false);
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [plansError, setPlansError] = useState('');
  const serverUrl = getApiBaseUrl();
  const isLoggedInUser = Boolean(userInfo?.userId);

  useEffect(() => {
    // API에서 상품 목록 불러오기
    fetch(`${serverUrl}/toss/plans`)
      .then(res => res.json())
      .then(data => {
        if (data.success && Array.isArray(data.data) && data.data.length > 0) {
          // API 데이터를 프론트엔드 형식으로 변환
          const formattedPlans = data.data.map(plan => ({
            id: plan.plan_code,
            label: plan.plan_name,
            amount: plan.amount,
            pages: `최대 ${plan.pages_max.toLocaleString()}페이지`,
            desc: plan.description,
            badge: plan.bonus_percent > 0 ? `${plan.bonus_percent}% 추가 제공` : null,
            isRecommended: plan.is_recommended === 1 || plan.is_recommended === '1' || plan.is_recommended === true
          }));
          setPlans(formattedPlans);
          setPlansError('');
        } else {
          setPlans([]);
          setPlansError(data.message || '상품 목록을 불러오지 못했습니다.');
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('상품 목록 조회 실패:', err);
        setPlans([]);
        setPlansError('상품 목록을 불러오지 못했습니다.');
        setLoading(false);
      });
  }, [serverUrl]);

  if (loading) {
    return (
      <main className="charge-page">
        <div className="charge-container">
          <p style={{ textAlign: 'center', padding: '2rem' }}>로딩 중...</p>
        </div>
      </main>
    );
  }

  if (!isLoggedInUser) {
    return (
      <main className="charge-page">
        <div className="charge-container">
          <h1 className="charge-title">이용권 충전</h1>
          <p style={{ textAlign: 'center', padding: '2rem', color: '#888' }}>
            로그인 후 이용권을 충전할 수 있습니다.
          </p>
        </div>
      </main>
    );
  }

  return (
    <main className="charge-page">
      <div className="charge-container">
        <h1 className="charge-title">이용권 충전</h1>
        <p className="charge-sub">충전한 이용권은 결제 후 즉시 반영됩니다.</p>
        {userInfo?.userId && (
          <p className="charge-user"><strong>아이디 : </strong><strong>{userInfo.userId}</strong></p>
        )}
        {plansError && (
          <p style={{ textAlign: 'center', padding: '1rem', color: '#c0392b' }}>
            {plansError}
          </p>
        )}

        {!selectedPlan ? (
          <>
            <div className="plan-grid">
              {plans.map((plan) => (
                <button
                  key={plan.id}
                  className={`plan-card${plan.isRecommended ? ' recommended' : ''}`}
                  onClick={() => setSelectedPlan(plan)}
                >
                  {plan.isRecommended && <span className="plan-recommended-mark">추천</span>}
                  <div className="plan-header">
                    <span className="plan-label">
                      {plan.label}
                      {plan.badge && <span className="plan-badge">{plan.badge}</span>}
                    </span>
                    <span className="plan-amount">{plan.amount.toLocaleString()}원</span>
                  </div>
                  <p className="plan-desc">{plan.desc}</p>
                  <p className="plan-pages">{plan.pages}</p>
                </button>
              ))}
            </div>
            <div className="refund-policy-link">
              <button onClick={() => setShowRefundModal(true)} className="btn-refund-policy">
                환불 정책 확인하기
              </button>
            </div>
          </>
        ) : (
          <TossPayment
            amount={selectedPlan.amount}
            orderName={`매쓰테일러 AI 이용권 ${selectedPlan.amount.toLocaleString()}원`}
            planCode={selectedPlan.id}
            onClose={() => setSelectedPlan(null)}
          />
        )}
      </div>

      {showRefundModal && (
        <RefundPolicyModal onClose={() => setShowRefundModal(false)} />
      )}
    </main>
  );
};

export default Charge;
